var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-full",class:[_vm.online ? 'bg-success' : 'bg-grey', `h-${_vm.size}`, `w-${_vm.size}`]})
}
var staticRenderFns = []

export { render, staticRenderFns }